import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function headerToggle() {
  return {
    type: constants.HEADER_TOGGLE,
  };
}

export function headerSelectSubmenu(submenu) {
  return {
    type: constants.HEADER_SUBMENU,
    submenu
  };
}

/******************************
*******  Asynchronous  ********
******************************/




// WEBPACK FOOTER //
// ./src/actions/header.jsx